import { DOCUMENT, ɵgetDOM as getDOM } from '@angular/common';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable()
export class SharedStylesHost {
  /** @internal */
  protected _stylesSet = new Set<string>();

  addStyles(styles: string[]): void {
    const additions = new Set<string>();
    styles.forEach(style => {
      if (!this._stylesSet.has(style)) {
        this._stylesSet.add(style);
        additions.add(style);
      }
    });
    this.onStylesAdded(additions);
  }

  onStylesAdded(additions: Set<string>): void { }

  removeStyles() {
    // Somehow a required function
  }

  getAllStyles(): string[] {
    return Array.from(this._stylesSet);
  }
}

@Injectable()
export class CustomDomSharedStylesHost extends SharedStylesHost implements OnDestroy {
  // Maps all registered host nodes to a list of style nodes that have been added to the host node.
  private readonly _hostNodes = new Map<Node, Node[]>();
  private cspToken: string = "";

  constructor(@Inject(DOCUMENT) private readonly _doc: any, private readonly metaService: Meta) {
    super();
    this._hostNodes.set(_doc.head, []);

    if (!this.cspToken) {
      this.cspToken = this.randomString(20);
    }

    let i = 0;
    let tim = setInterval(() => {

      let cspTag = this.metaService.getTag('http-equiv=Content-Security-Policy');

      let contentStr = "default-src 'self'; style-src 'self' 'nonce-" + this.cspToken + "'; base-uri 'self'; object-src 'self'; script-src 'self' 'nonce-" + this.cspToken + "';img-src 'self' data:;connect-src 'self'";

      if (cspTag) {
        this.metaService.removeTag('http-equiv=Content-Security-Policy');
      }
      this.metaService.addTag({ 'http-equiv': 'Content-Security-Policy', content: contentStr });

      if (i == 1) clearInterval(tim);
      i++;
    }, 1000);
  }

  private _addStylesToHost(styles: Set<string>, host: Node, styleNodes: Node[]): void {
    styles.forEach((style: string) => {
      const styleEl = this._doc.createElement('style');
      styleEl.textContent = style;
      if (!this.cspToken) {
        this.cspToken = this.randomString(20);
      }
      styleEl.setAttribute('nonce', this.cspToken); // Add nonce      
      styleNodes.push(host.appendChild(styleEl));
    });
  }

  addHost(hostNode: Node): void {
    const styleNodes: Node[] = [];
    this._addStylesToHost(this._stylesSet, hostNode, styleNodes);
    this._hostNodes.set(hostNode, styleNodes);
  }

  removeHost(hostNode: Node): void {
    const styleNodes = this._hostNodes.get(hostNode);
    if (styleNodes) {
      styleNodes.forEach(removeStyle);
    }
    this._hostNodes.delete(hostNode);
  }

  override onStylesAdded(additions: Set<string>): void {
    this._hostNodes.forEach((styleNodes, hostNode) => {
      this._addStylesToHost(additions, hostNode, styleNodes);
    });
  }

  ngOnDestroy(): void {
    this._hostNodes.forEach(styleNodes => styleNodes.forEach(removeStyle));
  }

  randomString(length: number): string {
    let randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    let randomValues = this.randomValues(length);
    for (let i = 0; i < length; i++) {
      result += randomChars[randomValues[i] % randomChars.length]
    }
    return result;
  }

  randomValues(length: number): Uint32Array {
    let values = new Uint32Array(length);
    window.crypto.getRandomValues(values);
    return values;
  }
}

function removeStyle(styleNode: Node): void {
  getDOM().remove(styleNode);
}